import { useState, useEffect } from 'react';
import { CustomerInfo } from '../types/translations';
import { useTranslations } from './useTranslations';

/**
 * 顧客情報を管理するフック
 * window.wakoCustomerInfoから顧客データを取得し、承認状態などを判定する
 */
export const useCustomerInfo = () => {
  const [customerInfo, setCustomerInfo] = useState<CustomerInfo | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const t = useTranslations();

  const customerInfoFromWindow: CustomerInfo = window.wakoCustomerInfo || {
    isLoggedIn: false,
    id: null,
    email: null,
    firstName: null,
    lastName: null,
    tags: []
  };

  // 承認済みかどうかを判定
  const isApproved = customerInfoFromWindow.tags.includes('approved');

  // 注文可能かどうかを判定（ログイン済み + 承認済み）
  const canOrder = customerInfoFromWindow.isLoggedIn && isApproved;

  // 承認待ち状態かどうかを判定（ログイン済み + 未承認）
  const isPendingApproval = customerInfoFromWindow.isLoggedIn && !isApproved;

  const getOrderStatusMessage = (): string => {
    if (!customerInfoFromWindow?.isLoggedIn) {
      return t.customerInfo_loginRequired;
    }
    if (isPendingApproval) {
      return t.customerInfo_approvalPending;
    }
    if (canOrder) {
      return t.customerInfo_canOrder;
    }
    return t.customerInfo_statusChecking;
  };

  return {
    // 基本情報
    ...customerInfoFromWindow,
    
    // 計算されたステータス
    isApproved,
    canOrder,
    isPendingApproval,
    
    // 表示用のステータス文字列
    getStatusMessage: getOrderStatusMessage
  };
}; 